import axios from 'axios';
// import { ElMessageBox } from 'element-plus'
const project = require('/public/static/project.json')

let baseUrl = process?.env?.VUE_APP_BASE_URL
if (!baseUrl) {
    // 未提供后台地址时，使用当前域名
    baseUrl = window.location.origin
} else {
    if (baseUrl.indexOf('{') !== -1) {
        // 存在花括号代表有参数需要替换
        /* 可使用的参数例子
        host: "localhost:8080"
        hostname: "localhost"
        origin: "http://localhost:8080"
        port: "8080"
        protocol: "http:"
        */
        ['host', 'hostname', 'origin', 'port', 'protocol'].forEach(key => {
            baseUrl = baseUrl.replace(`{${key}}`, window.location[key])
        })
    }
}

// axios拦截器，目的是为了在请求头上带上token
axios.interceptors.request.use(
    config => {
        // 存在 token 时不需要附加（登录时需要自己控制 用户令牌、账套令牌）
        if (!config?.headers?.Authorization) {
            const storageName = `tw_${project.project_id}_user`
            const userLocalStorage = localStorage.getItem(storageName)
            if (userLocalStorage) {
                const user = JSON.parse(userLocalStorage)
                if (user.expires_in) {
                    var today = new Date();
                    // 令牌未过期时才加到 headers 上
                    if (Date.parse(user.expires_in) - Date.parse(today) >= 0) {
                        config.headers.common["Authorization"] = `Bearer ${user.token}`
                    }
                }
            }
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
)

const httpService = function() {

    var pri = {
        apis: []
    }

    var buildUrl = function(method, no, params) {
        let url
        const api = pri.apis.find(el => el.no === no)
        if (api) {
            // 有指定http方法时使用方法的url，否则使用公共url
            url = api[method] && api[method].url || api.url
            if (url && url[0] === '/') {
                // 以 / 开头的地址拼上当前配置的
                url = baseUrl + url
            }
            // 获取url中的变量（冒号后面的变量）
            // const urlParams = /:[0-9,a-z,A-Z,_,-]+/g.exec(url)
            const querys = []

            if (params) {
                Object.keys(params).forEach(key => {
                    const value = params[key]
                    if (url.indexOf(`:${key}`) !== -1) {
                        url = url.replace(`:${key}`, value)
                    } else {
                        querys.push(`${key}=${value}`)
                    }
                })
            }

            if (querys.length) {
                url += `?${querys.join('&')}`
            }
        }
        return url
    }

    var pub = {
        // 获取数据
        get(no, params, responseType) {
            const apiName = no?.name ?? no
            const url = buildUrl('get', apiName, params)
            if (url) {
                const config = {
                    method: 'get',
                    url: url
                }
                if (no?.headers) {
                    config['headers'] = no.headers
                }
                if (responseType) {
                    config.responseType = responseType
                }
                return axios(config).then(res => {
                    const result = res.data
                    // 获取文件时并不是对象类型，所以判断
                    if (Object.prototype.toString.call(result) === '[object Object]') {
                        if (result.status === '200') {
                            return result.data;
                        } else {
                            return Promise.reject({
                                status: result.status,
                                message: result.message,
                                data: result.data
                            })
                        }
                    } else {
                        return result
                    }
                })
            }
        },
        put(no, params, data) {
            const apiName = no?.name ?? no
            const url = buildUrl('put', apiName, params)
            if (url) {
                const config = {
                    method: 'put',
                    url: url,
                    data: data
                }
                if (no?.headers) {
                    config['headers'] = no.headers
                }
                return axios(config).then(res => {
                    const result = res.data
                    if (result.status === '200') {
                        return result.data;
                    } else {
                        return Promise.reject({
                            status: result.status,
                            message: result.message,
                            data: result.data
                        })
                    }
                })
            }
        },
        post(no, params, data) {
            const apiName = no?.name ?? no
            const url = buildUrl('post', apiName, params)
            if (url) {
                const config = {
                    method: 'post',
                    url: url,
                    data: data
                }
                if (no?.headers) {
                    config['headers'] = no.headers
                }
                return axios(config).then(res => {
                    const result = res.data
                    if (result.status === '200') {
                        return result.data;
                    } else {
                        return Promise.reject({
                            status: result.status,
                            message: result.message,
                            data: result.data
                        })
                    }
                })
            }
        },
        delete(no, params) {
            const apiName = no?.name ?? no
            const url = buildUrl('delete', apiName, params)
            if (url) {
                const config = {
                    method: 'delete',
                    url: url
                }
                if (no?.headers) {
                    config['headers'] = no.headers
                }
                return axios(config).then(res => {
                    const result = res.data
                    if (result.status === '200') {
                        return result.data;
                    } else {
                        return Promise.reject({
                                status: result.status,
                                message: result.message,
                                data: result.data
                            })
                    }
                })
            }
        }
    }

    // 加载后台接口地址
    pri.apis = require('../../public/static/apis.json')
    // 加载用户定义的后台接口，使用绝对路径才可以加载具体项目上定义的接口，而不是 tw-framework 项目
    try {
        const controllers = require('/public/static/controllers.json')
        pri.apis.push(...controllers)
    } catch (error) {
        // 项目未提供后台接口时
    }
    

    return pub;
}

var service = httpService();

export default service;